import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left_7abfd523cc03ece146a5c040c99a6bb0",
  "use": "arrow-left_7abfd523cc03ece146a5c040c99a6bb0-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-left_7abfd523cc03ece146a5c040c99a6bb0\">\n    <path fill-rule=\"nonzero\" d=\"M4.218 13.196l8.078 8.125a.815.815 0 0 1 0 1.149l-.538.542a.806.806 0 0 1-1.144 0L.237 12.574a.815.815 0 0 1 0-1.148L10.613.988a.806.806 0 0 1 1.144 0l.54.542a.815.815 0 0 1 0 1.149l-8.079 8.125h18.973a.81.81 0 0 1 .809.813v.766a.81.81 0 0 1-.809.813H4.218z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol